<template>
  <div>
    <v-server-table id="table-histo-sinistre" :columns="columns" ref="histo_table" :options="options" style="overflow: hidden;">
      <div slot="beforeFilter"><router-link :to="fiche(dossier.nir)" target="_blank">Afficher fiche salarié</router-link></div>
      <div slot="source" slot-scope="props">
        <b>{{ props.row.id }}</b> <br> {{ props.row.canal.libelle }}
      </div>
      <div slot="date_reception" slot-scope="props" v-html="getFormatedDate(props.row.date_reception)">
      </div>
      <div slot="dossier_type" slot-scope="props" v-html="getInfosTypeTraitement(props.row)">
      </div>
      <div slot="siren" slot-scope="props">
        <b style="color: rgb(217, 65, 139);">{{ props.row.siren ? props.row.siren.siren : 'n.d' }} (OAG </b><b style="color: #ff0032;">{{ props.row.oag }}</b><b style="color: rgb(217, 65, 139);">  OAP</b><b style="color: #ffa434;"> {{ props.row.oap }}</b><b style="color: rgb(217, 65, 139);">)</b><br>
        <!-- <b style="color: rgb(217, 65, 139);">{{ getSiret(props.row)  }} (OAG </b><b style="color: #ff0032;">{{ props.row.oag }}</b><b style="color: rgb(217, 65, 139);">  OAP</b><b style="color: #ffa434;"> {{ props.row.oap }}</b><b style="color: rgb(217, 65, 139);">)</b><br> -->
        <span class="text-success">{{ props.row.siren ? props.row.siren.raison_sociale : 'n.d' }}</span>
      </div>
      <div slot="produit" slot-scope="props" v-html="getInfosSegmentProduit(props.row)">
      </div>
      <div slot="date_debut_periode" slot-scope="props">
        <span :id="'tooltip-detail-sinistre-'+props.row.id" class="text-center" v-html="getDatePeriode(props.row)"><img
          class="pull-right" v-if="hasTooltipDetailSinistre(props.row)" :src="getIconPostit('corner')"></i></span>
        <b-tooltip v-if="hasTooltipDetailSinistre(props.row)"  :target="'tooltip-detail-sinistre-'+props.row.id" triggers="hover" custom-class="pre-formatted" placement="right">
          <ul class="ul-tooltip">
            <li>{{ props.row.montant_ij_ss }} €</li>
          </ul>
        </b-tooltip>
      </div>

      <div slot="status" slot-scope="props" v-html="'<b>'+getStatus(props.row, 'parent')+'</b><br>'+getStatus(props.row, 'sousStatut')"></div>

      <div slot="gestionnaire" slot-scope="props" v-html="getInfosGestionnaire(props.row)"></div>

      <div slot="notes" slot-scope="props" class="text-center">
        <span :id="'tooltip-note-'+props.row.id" class="text-center">
          <img class="clickable" :src="getIconPostit('post-it', props.row)" @click="editCommentaire(props.row)">
        </span>
        <b-tooltip v-if="props.row.commentaires_gestion.length > 0" :target="'tooltip-note-'+props.row.id" triggers="hover" custom-class="pre-formatted" placement="left">
          <ul class="ul-tooltip">
            <li v-for="commentaire of props.row.commentaires_gestion">
              {{ commentaire.texte }}
            </li>
          </ul>
        </b-tooltip>
      </div>

      <div slot="action" slot-scope="props">
        <b-button
          v-if="dossier.id !== props.row.id && props.row.pieces_jointes.length > 0"
          type="button"
          @click.prevent="showPiecesJointes(props.row.pieces_jointes)"
          class="badge badge-primary p-2">
          <i class="fa fa-paperclip" title="Voir les pièces jointes"></i>
        </b-button>
      </div>
      <div slot="detail" slot-scope="props">
        <router-link :to="getDossierDetail(props.row)" target="_blank" class="badge badge-primary p-2">
          <i class="fa fa-search" title="Voir le dossier"></i>
        </router-link>
      </div>
    </v-server-table>
    <b-modal title="pièce(s) jointe(s)" v-model="modalShow" size="xl">
      <div class="table-wrapper">
            <div class="table-scroll">
              <table class="table">
                <thead>
                <tr>
                  <th scope="col">N° Dossier</th>
                  <th scope="col">Date de réception</th>
                  <th scope="col">Libellé</th>
                  <th scope="col">Taille</th>
                  <th style="text-align: center">Visibilité</th>
                  <th style="text-align: center">Télécharger</th>
                  <th :hidden="cantEditFicheDC(dossier)">
                    <b-form-checkbox
                      v-model="allSelected"
                      :indeterminate="indeterminate"
                      aria-describedby="items"
                      aria-controls="items"
                      @change="toggleAll"
                    >
                    </b-form-checkbox>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(pj, key) in piecesJointes" :key="key">
                  <td><img style="width: 30px;" class="mr-2" :src="getIcon(pj)">{{ getPjDossierId(pj) }}</td>
                  <td> {{ shortFormatDate(pj.date_reception) }}</td>
                  <td> {{ reducedFileName(pj.name) }}</td>
                  <td>{{ getReadableFileSize(pj.size) }}</td>
                  <td style="text-align: center">
                    <i title="Visible pour le client" v-if="pj.is_visible_for_client" class="fa fa-eye fa-2x"></i>
                    <i title="Non visibile pour le client" v-if="!pj.is_visible_for_client" class="fa fa-eye-slash fa-2x"></i>
                  </td>
                  <td style="text-align: center">
                    <b-button type="button"
                              title="télécharger"
                              @click="download(pj.id,pj.name)"
                              size="sm"
                              variant="secondary">
                      <i class="fa fa-download"></i>
                    </b-button>
                  </td>
                  <td :hidden="cantEditFicheDC(dossier)">
                    <b-form-checkbox v-model="selectedRows" :value="pj.id"></b-form-checkbox>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
      <template v-slot:modal-footer>
        <span v-if="emptyAttachedPiecesJointes" class="field-error w-50">Veuillez séléctionner une pièce jointe</span>
        <div class="w-50 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="closeModal">Annuler</button>
          <button type="button" @click="attacher" class="btn btn-primary" v-if="!cantEditFicheDC(dossier)">Attacher</button>
        </div>
      </template>
    </b-modal>
    <b-modal size="xl" scrollable id="modal-commentaire" ref="modal-commentaire" title="Commentaires sur le dossier">
      <b-row v-for="(commentaire,key) of commentairesGestion" class="align-items-center" :key="commentaire.id">
        <b-col md="10" style="display: inline-block;">
          <label>Commentaire
            <span class="smaller-2">
              <i>Dernière modification le {{ formatDateHeure(commentaire.updated_at) }}
                par <span v-if="commentaire.gestionnaire != null">{{ commentaire.gestionnaire.prenom }} {{ commentaire.gestionnaire.nom }}</span>
                <span v-else> Système </span>
              </i>
            </span>
          </label>
          <div class="border pt-2 pb-3 pl-2 pr-2">{{ commentaire.texte }}</div>
        </b-col>
        <b-col md="2" class="align-middle" :hidden="cantEditFicheDC(dossier)">
          <b-form-checkbox v-model="commentaire.is_urgent" name="check-button"
                           switch disabled> Urgent
          </b-form-checkbox>
          <b-form-checkbox v-model="commentaire.is_relation_client" name="check-button"
                           switch disabled> Relation Client
          </b-form-checkbox>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
  import { getUser, hasHabilitationOagOapDossier } from "@/utils/auth";
  import moment from 'moment';
  import { downloadFile, isEmpty, getIconSrc as getIconSrcMain, getReadableFileSize as getReadableFileSizeMain } from "@/utils/fileHelper";
  import {getMainTreatmentBasedOnType, formatDate, formatDateTime, getIconPostit, cantEditFicheDC} from "@/utils/communHelper";
  import { hasRule, espaceGestionRules as rules } from "@/utils/rulesHelper";

  export default {
    name: "HistoriqueSinistres",
    data() {
      let self = this;
      return {
        // relatedDossiers: [],
        getIconPostit,
        numArchives: '',
        dateReception: '',
        garantie: '',
        type: '',
        nir: '',
        ppNumber: '',
        selectedSegment: null,
        produit: '',
        nom: '',
        prenom: '',
        pjNumber: '',
        collaborateurAffecte: '',
        equipeAffecte: '',
        statut: '',
        allSelected: [],
        selectedRows: [],
        piecesJointes: [],
        modalShow: false,
        indeterminate: false,
        options: {
          headings: {
            'source': 'N° dossier\nCanal récep.',
            'date_reception': 'Date de\nréception',
            'dossier_type': 'Type\nTraitement',
            'siren':'SIREN\nRaison Sociale',
            'produit': 'Segment\nProduit',
            'status': 'Statut\nSous-statut',
            'date_debut_periode': this.getTitleColonneDebutPeriode(), //'Début période\nFin période',
            'gestionnaire': 'Affectation',
            'notes': 'Notes',
            'action': 'Action\nPJ',
            'detail': '#',
          },
          columnsClasses: {
            dossier_type: 'pre-formatted tooltip-cell sort-top',
            siren: 'pre-formatted sort-top',
            produit: 'pre-formatted sort-bottom',
            gestionnaire: 'pre-formatted',
            status: 'pre-formatted',
            source: 'pre-formatted sort-top',
            date_debut_periode: 'pre-formatted',
            date_reception: 'pre-formatted align-middle sort-middle',
            notes: 'align-middle action-xs text-center',
            action: 'align-middle action-xs text-center',
            detail: 'align-middle action-xs text-center',
          },
          cellClasses:{
            source: [{
              class:'dossier-prioritaire-urgences-directions',
              condition: row => row.type_urgence === 'urgences_directions'
            },
            {
              class:'dossier-prioritaire-lignes-rouges',
              condition: row => row.type_urgence === 'lignes_rouges'
            },
            {
              class:'dossier-prioritaire-fiche-tel',
              condition: row => row.type_urgence === 'fiche_telephonique'
            }
            ],

          },
          rowClassCallback(row) {
            return parseInt(row.id,10) === parseInt(self.dossier.id,10) ? 'same-dossier borded' : '';
          },
          sortable: ['date_reception', 'date_debut_periode'],
          filterable: false,
          perPage: 10,
          perPageValues: [1, 10, 25],
          orderBy: { ascending: true},
          requestFunction: function (data) {
            self.url = '/espaceGestion/dossier/getRelatedDossiersByNir/' + self.dossier.id;
            return axios.get(self.url, {
              params: data
            })
              .then(function(response){
                // self.$store.commit('IS_LOADING', false);

                let relatedDossier = response.data.data;
                let filteredRelatedDossier = relatedDossier.filter(dossier => hasHabilitationOagOapDossier(dossier))
                // self.findDossiers = response.data.data;
                // self.relatedDossiers = response.data.data;
                response.data.data = filteredRelatedDossier;

                self.$event.emit('stopLoadingHisto');

                // console.log('response.data',response.data)
                return response;
              })
              .catch(function (e) {
                console.log(e);
                // self.$store.commit('IS_LOADING', false);
                self.$event.emit('stopLoadingHisto');
                self.$swal({
                  position: 'top',
                  type: 'error',
                  title: 'Attention !!',
                  text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
                  showConfirmButton: false,
                  timer: 5000
                });
              }.bind(this));
          },
          // responseAdapter(data) {
          //   console.log(data)
          //   self.relatedDossiers = data.data[0].data;
          //   return {
          //     data: data.data[0].data,
          //     count: data.data[0].count
          //   }
          // },
        },
        columns: ['source', 'date_reception', 'dossier_type', 'siren', 'produit', 'date_debut_periode', 'status', 'gestionnaire', 'notes', 'action', 'detail'],
        url: '',
        emptyAttachedPiecesJointes: false,
        commentairesGestion: [],
      }
    },
    watch: {
      allTraitements() {
        this.$refs.histo_table.refresh();
      }
    },
    props: ['segments', 'dossier', 'allTraitements'],
    mounted() {
      this.getAllTraitements();
      this.$event.on('refreshHistoSinistre', () => {
        this.$refs.histo_table.refresh();
      });
    },
    methods: {
      formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
      },
      getFormatedDate(textDate) {
        return formatDate(textDate);
      },
      formatDateHeure(textDate) {
        let date = textDate !== null ? new Date(textDate).toLocaleString("fr-FR") : "-";
        return date;
      },
      hasTooltipDetailSinistre(row){
        if(!isEmpty(row.type) && row.type.groupe.toLowerCase() === 'ij'){
          if(row.date_debut_periode || row.date_fin_periode || row.montant_ij_ss){
            return true;
          }
        }
        return false;
      },
      formatNir(textNir) {
        if (textNir !== null && textNir !== '') {
          let displayNir = ''

          displayNir = textNir.substring(0, 1) + ' ' + textNir.substring(1, 3) + ' ' + textNir.substring(3, 5) + ' ' + textNir.substring(5, 7) + ' ' + textNir.substring(7, 10) + ' ' + textNir.substring(10, 13) + ' ' + textNir.substring(13, 15)
          return displayNir
        } else {
          return textNir
        }
      },
      getDelai(date) {
        moment.locale('fr')
        let today = moment()
        let momentDate = moment(date, 'YYYY-MM-DD hh:mm:ss')

        if (!momentDate.isValid()) {
          return '-'
        }
        let delai = today.diff(momentDate, 'days') < 2 ? today.diff(momentDate, 'days') + ' jour' : today.diff(momentDate, 'days') + ' jours'

        return delai
      },
      getEquipe(dossier) {
        let equipeNames = '-'
        let gestionnaire = {equipes: []}

        if (dossier) {
          if (dossier.gestionnaires) {
            for (let gest of dossier.gestionnaires) {
              if (parseInt(gest.pivot.traitement_id,10) === parseInt(this.$route.query.traitementId,10)) {
                gestionnaire = gest
              }
            }
          }
          for (let equipe of gestionnaire.equipes) {
            equipeNames = equipeNames === '-' ? equipe.libelle : equipeNames + '/' + equipe.libelle
          }
        }

        return equipeNames
      },
      getInfosGestionnaire(dossier) {
        let gest = this.getGestionnaire(dossier);
        let equipe = this.getEquipe(dossier);

        return gest + '<br><span class="text-primary">' + equipe + '</span>';
      },
      getGestionnaire(dossier) {
        let gestionnaire = null
        let gestionnaireQualification = null
        // On cherche le gestionnaire pour les traitements principaux "classique"
        for (let gest of dossier.gestionnaires) {
          if (gest.pivot.traitement_id === this.getTraitementIdByLibelleTehnique('ij_gestion_prestation')) {
            gestionnaire = gest;
          } else if (gest.pivot.traitement_id === this.getTraitementIdByLibelleTehnique('gestion_inval')) {
            gestionnaire = gest;
          } else if (gest.pivot.traitement_id === this.getTraitementIdByLibelleTehnique('gestion_dc')) {
            gestionnaire = gest;
          } else if (gest.pivot.traitement_id === this.getTraitementIdByLibelleTehnique('gestion_dbco')) {
            gestionnaire = gest;
          } else if (gest.pivot.traitement_id === this.getTraitementIdByLibelleTehnique('qualification_courrier')) {
            gestionnaireQualification = gest;
          }
        }
        // Si on n'a pas trouvé de gestionnaire, on regarde pour le traitement module prev'
        if (!gestionnaire) {
          for (let gest of dossier.gestionnaires) {
            if (gest.pivot.traitement_id === this.getTraitementIdByLibelleTehnique('ij_module_prevoyance')) {
              gestionnaire = gest;
            }
          }
        }
        let response = '';
        if (gestionnaire) {
          response = gestionnaire.nom.toUpperCase() + ' ' + gestionnaire.prenom;
        // } else if (gestionnaireQualification) {
        //   response = gestionnaireQualification.nom.toUpperCase() + ' ' + gestionnaireQualification.prenom;
        } else {
          response = '-';
        }
        return response;
      },
      getStatus(dossier, type) {
        // console.log('dossier',dossier)
        let response = '';
        let otherStatus = null;
        let statusQualification = null;
        // On cherche le traitement "classique" du dossier (IJ, Inval, dc, QC)
        for (let status of dossier.status) {
          if (status.pivot.traitement_id === this.getTraitementIdByLibelleTehnique('ij_gestion_prestation')) {
            otherStatus = status;
          } else if (status.pivot.traitement_id === this.getTraitementIdByLibelleTehnique('gestion_inval')) {
            otherStatus = status;
          } else if (status.pivot.traitement_id === this.getTraitementIdByLibelleTehnique('gestion_dc')) {
            otherStatus = status;
          } else if (status.pivot.traitement_id === this.getTraitementIdByLibelleTehnique('gestion_dbco')) {
            otherStatus = status;
          } else if (status.pivot.traitement_id === this.getTraitementIdByLibelleTehnique('qualification_courrier')) {
            statusQualification = status;
          }
        }
        // Si on a rien trouvé, on regarde si on est sur un dossier en module prev' seulement
        if (!otherStatus) {
          for (let status of dossier.status) {
            if (status.pivot.traitement_id === this.getTraitementIdByLibelleTehnique('ij_module_prevoyance')) {
              otherStatus = status;
            }
          }
        }
        response = otherStatus !== null ? otherStatus : null;

        if (type === 'parent') {
          if (response) {
            response = response.parent ? response.parent.libelle_bo : response.libelle_bo;
          } else {
            response = 'n.d.'
          }
        } else if (type === 'sousStatut') {
          if (response) {
            response = response.parent ? response.libelle_bo.trim() : '-';
          } else {
            response = 'n.d.'
          }
        }
        // console.log('getStatus', response)
        return response;
      },
      showPiecesJointes(piecesJointes) {
        let pjVisibles = _.filter(piecesJointes, (pj) => pj.is_from_client === true && pj.type_principal_id !== 75);
        this.piecesJointes = pjVisibles;
        this.modalShow = true;
      },
      shortFormatDate(textDate) {
        let formattedDate = null;
        if(!isEmpty(textDate)) {
          let date = new Date(textDate).toLocaleDateString("fr-FR").split('/');
          formattedDate = `${date[0]}/${date[1]}/${date[2].slice(-2)}`;
        } else {
          formattedDate = '-';
        }
        return formattedDate;
      },
      reducedFileName(name) {
        if (name.length > 30) {
          return name.substring(0, 29) + ' ...';
        } else {
          return name;
        }
      },
      getReadableFileSize(fileSizeInBytes) {
        return getReadableFileSizeMain(fileSizeInBytes)
      },
      getIcon(pj) {
        return getIconSrcMain(pj)
      },
      getTextDate(dateDebut, dateFin) {
        let joinDate = ''
        if (isEmpty(dateDebut) && isEmpty(dateFin)) {
          joinDate = '';
        } else {
          joinDate = '<b>' + this.shortFormatDate(dateDebut) + '</b> au <b>' + this.shortFormatDate(dateFin) + '</b>';
        }
        return joinDate
      },
      getDatePeriode(dossier) {
        if(!isEmpty(dossier.type) && dossier.type.libelle_technique === 'dbco'){
          return formatDateTime(dossier.date_signature, '/')
        }else if(!isEmpty(dossier.regle_cumul)){
          return this.getTextDate(dossier.date_debut_periode, dossier.date_fin_periode) + '<br>' + dossier.regle_cumul.libelle
        }else{
          return this.getTextDate(dossier.date_debut_periode, dossier.date_fin_periode) + '<br>' + 'Règle de cumul non spécifiée'
        }
      },
      toggleAll(checked) {
        this.selectedRows = checked ? this.piecesJointes.map(item => {return item.id}) : []
      },
      closeModal() {
        this.modalShow = false;
        this.selectedRows = [];
        this.allSelected = [];
        this.piecesJointes = [];
      },
      attacher() {
        if(this.selectedRows.length > 0) {
          this.emptyAttachedPiecesJointes = false;
          let dataPost = {};
          dataPost.dossier_id = this.dossier.id;
          dataPost.traitement_id = this.$route.query.traitementId;
          dataPost.pieces_jointes_id = this.selectedRows;
          this.$axios
            .post("/espaceGestion/dossier/attacherPiecesJointes", dataPost)
            .then(() => {
              this.selectedRows = [];
              this.modalShow = false;
              this.$swal({
                position: 'top',
                type: 'success',
                title:'Attachement avec succès',
                text:'Attachement avec succès',
                showConfirmButton: false,
                timer: 4000
              });
            });
        } else {
          this.emptyAttachedPiecesJointes = true;
        }
      },
      download(id, filename) {
        let fileNameArr = filename.trim().split('.');
        let ext = fileNameArr.pop();
        let name = fileNameArr.join('.');
        this.$axios
          .get("/espaceGestion/dossier-pieces-jointes/download/"+id, {responseType: 'blob'})
          .then(response => {
            downloadFile(response, name, ext, '_BLANK');
          })
          .catch(() => {
            this.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 4000
            });
          })
      },
      getInfosTypeTraitement(dossier) {
        let type = dossier.type && dossier.type.libelle_technique === 'dbco' ? dossier.type.libelle+' ('+dossier.dbco_type+')' : (dossier.type ? dossier.type.libelle : 'n.d');
        let traitementDossier = this.getDossierMainTreatment(dossier);
        let fontColor = !isEmpty(traitementDossier.font_color) ? traitementDossier.font_color : '#23282c';

        return type + '<br><span v-b-tooltip.hover :title="'+traitementDossier.libelle+'" style="color: '+fontColor+'">'+traitementDossier.libelle_court+'</span>';
      },
      getDossierMainTreatment(dossier) {
        let defaultTreatment = this.allTraitements.reduce((res, treatment) => {
          return parseInt(treatment.id) === parseInt(this.$route.query.traitementId) ? treatment : res;
        }, null);

        let mainTreatment = getMainTreatmentBasedOnType(dossier, this.allTraitements);

        return !isEmpty(mainTreatment) ? mainTreatment : defaultTreatment;
      },
      getAllTraitements() {
        this.allTraitements = this.$parent.$parent.$parent.allTraitements;
      },
      getTraitementByLibelleTechnique(libelle_technique) {
        let treatment = _.find(this.allTraitements, function (element) {
          return element.libelle_technique === libelle_technique;
        });
        return treatment;
      },
      getLibelleTraitement(type) {
        let traitement = this.allTraitements.reduce((res, treatment) => {
          return parseInt(treatment.id) === parseInt(this.$route.query.traitementId) ? treatment : res;
        }, null)
        if (traitement) {
          // console.log(traitement)
          return type === 'court' ? traitement.libelle_court : traitement.libelle
        }
        return '';
      },
      getTraitementIdByLibelleTehnique(libelle_technique) {
        let treatment = _.find(this.allTraitements, function(element) {
          return element.libelle_technique === libelle_technique;
        });
        return treatment && treatment.id;
      },
      getInfosSegmentProduit(dossier) {
        let segment = this.getSegmentGestion(dossier);
        let produit = dossier.famille_produit ? dossier.famille_produit.libelle : 'n.d';

        return segment + '<br><span style="color: #F96706;">' + produit + '</span>';
      },
      getSegmentGestion(dossier) {
        let response = 'n.d';
        if (dossier.siren) {
          if (dossier.siren.preference) {
            response = dossier.siren.preference.segment_gestion.libelle;
          }
        }
        return response;
      },
      getPjDossierId(pj) {
        if (pj.dossier_source_id) {
          return pj.dossier_source_id;
        } else {
          if (pj.source === 'gestionnaire' || pj.source === 'mail') {
            return pj.dossier_id;
          } else {
            return pj.source_id ? pj.source_id : pj.dossier_id;
          }
        }
      },
      getTitleColonneDebutPeriode() {
        return !isEmpty(this.dossier.type) && this.dossier.type.libelle_technique === 'dbco' ? 'Date signature' : 'Dates période\nRègle Cumul';
      },
      getDossierDetail(dossier) {
        let dossierId = dossier.id;
        let user = getUser();
        let userOags = user.profil_active[0].oags.map(oag => oag.code);
        let traitement = getMainTreatmentBasedOnType(dossier, this.allTraitements);
        if (isEmpty(traitement)) {
          return null;
        } else {
          if (userOags.indexOf(dossier.oag) > -1) {
            return {
              path: '/espace-gestion/dossier/show/' + dossierId,
              query: {
                traitementId: traitement.id,
              }
            }
          } else {
            return null;
          }
        }
      },
      editCommentaire(dossier) {
        this.commentairesGestion = dossier.commentaires_gestion
        this.dossierIdForCommentaire = dossier.id
        this.$refs['modal-commentaire'].show()
        // console.log('this.commentaires[this.dossierIdForCommentaire]',this.commentaires[this.dossierIdForCommentaire])
        // console.log('this.commentairesGestion',this.commentairesGestion)
      },
      fiche(nir) {
        return {
          path: "/espace-gestion/assures/fiche/" + nir,
          query: {
            do: this.dossier.id,
            ns: this.dossier.nir,
            no: this.dossier.nom,
            pr: this.dossier.prenom,
            siren: this.dossier.siren,
            oag: this.dossier.oag,
            oap: this.dossier.oap,
            from: "histoSinistre"
          }
        };
      },
      cantEditFicheDC
    }
  }
</script>
<style scoped>
  .table-wrapper {
    position: relative;
  }
  .table-scroll {
    overflow: auto;
    margin-top: 10px;
  }
  #table-histo-sinistre td, #table-histo-sinistre th {
    vertical-align: middle;
  }
</style>
<style type="text/css">
  #table-histo-sinistre tr th {
    border-bottom: none;
  }
  #table-histo-sinistre tr.same-dossier {
    background-color: #f0f1f3;
  }
  #table-histo-sinistre tr.same-dossier.borded td {
    border-top: 1px solid #da7ec7 !important;
    border-bottom: 1px solid #da7ec7;
  }
  #table-histo-sinistre tr.same-dossier.borded td:first-child {
    border-left: 1px solid #da7ec7;
  }
  #table-histo-sinistre tr.same-dossier.borded td:last-child {
    border-right: 1px solid #da7ec7;
  }
  .tooltip.b-tooltip.pre-formatted .tooltip-inner {
    white-space: pre-line;
    max-width: 100% !important;
  }

  .tooltip.b-tooltip.pre-formatted {
    max-width: 100%;
  }

  tr td.tooltip-cell > div span {
    display: inline-block;
    width: 100%;
    padding: 0 0 0 0.75rem;
  }

  .ul-tooltip {
    padding: 0;
    list-style: none;
    margin-bottom: 0;
  }

  .dossier-prioritaire-urgences-directions {
    color: #fff;
    background-color: #f86c6b;
  }

  .dossier-prioritaire-lignes-rouges {
    color: #fff;
    background-color: #ff8800;
  }

  .dossier-prioritaire-fiche-tel {
    color: #fff;
    background-color: #ff7fe9;
  }

</style>
